// src/pages/approval/ApprovalCc.jsx
// ✅ 수신참조 목록(/approval/cc, 2026-10-19) — 내가 참조된 문서와 결재 결과·읽음 표시.
// 열면 읽음 처리한다. 휴가신청서는 미리보기 모달로, 다른 문서는 기존 기안 상세 화면으로 연다.
import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../api";
import LeaveDetailModal from "./LeaveDetailModal";
import styles from "./LeaveRequest.module.css";

const DOC_TYPE_LABEL = {
  income_draft: "수입기안",
  expense_draft: "지출기안",
  income_resolution: "수입결의",
  expense_resolution: "지출결의",
  leave_request: "휴가신청서",
};
const STATUS_LABEL = { pending: "결재중", approved: "승인", rejected: "반려" };

const resultText = (row) => {
  const d = row.decision;
  if (!d) return "-";
  if (d.result === "rejected") return `${d.approver_name} 반려${d.comment ? ` — ${d.comment}` : ""}`;
  if (d.result === "approved") return `${d.approver_name} ${d.approval_type === "전결" ? "전결" : "승인"}`;
  return `${d.approver_name} 대기`;
};

export default function ApprovalCc() {
  const navigate = useNavigate();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [openId, setOpenId] = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/draft/documents/cc/");
      setRows(Array.isArray(data) ? data : []);
    } catch {
      setRows([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  const open = async (row) => {
    if (!row.is_read) {
      try {
        await api.post(`/draft/references/${row.reference_id}/mark_read/`);
        setRows((prev) => prev.map((r) => (r.reference_id === row.reference_id ? { ...r, is_read: true } : r)));
      } catch {
        // 읽음 표시 실패는 열람을 막지 않는다
      }
    }
    if (row.document_type === "leave_request") setOpenId(row.document_id);
    else navigate(`/approval/draftdocument/${row.document_id}`);
  };

  const unread = rows.filter((r) => !r.is_read).length;

  return (
    <div className={styles.page}>
      <div className={styles.filters}>
        <h2 className={styles.title} style={{ margin: 0 }}>수신참조</h2>
        <span className={styles.summary} style={{ margin: 0 }}>{rows.length}건 · 안 읽음 {unread}건</span>
        <button type="button" className={styles.smallBtn} onClick={load}>새로고침</button>
      </div>
      <div className={styles.tableWrap}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>읽음</th><th>문서종류</th><th>문서번호</th><th>제목</th><th>기안자</th><th>작성일</th>
              <th>상태</th><th>결재 결과</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={8} className={styles.empty}>불러오는 중...</td></tr>
            ) : rows.length === 0 ? (
              <tr><td colSpan={8} className={styles.empty}>수신참조된 문서가 없습니다.</td></tr>
            ) : rows.map((r) => (
              <tr key={r.reference_id} className={`${styles.clickRow} ${r.is_read ? "" : styles.unread}`}
                  onClick={() => open(r)}>
                <td>{r.is_read ? `읽음${r.read_at ? ` ${r.read_at.slice(5, 10).replace("-", "/")}` : ""}` : "●"}</td>
                <td>{DOC_TYPE_LABEL[r.document_type] || r.document_type}</td>
                <td>{r.draft_no}</td>
                <td>{r.title}</td>
                <td>{r.created_by_name}</td>
                <td>{r.draft_date}</td>
                <td className={r.state ? styles[`state_${r.state}`] : undefined}>
                  {r.state_label || STATUS_LABEL[r.status] || r.status}
                </td>
                <td>{resultText(r)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {openId && <LeaveDetailModal documentId={openId} onClose={() => setOpenId(null)} />}
    </div>
  );
}
